import { store } from "../store";

export const handleSnackbarClose = () => {
  store.dispatch({ type: "snackbar/close", payload: false });
};
